import { Button, Card, CardActions, CardContent, IconButton, Link, TextField, makeStyles } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { FormBuilder } from '@zennya/web-component-library/src';
import { activeUserState } from 'pages/CustomerBooking';
import { PageHeader } from 'pages/CustomerBookingCreate/components/PageHeader';
import { PrivPolLink } from 'pages/CustomerBookingCreate/components/PrivPolLink';
import { STEP_CREATE_ACCOUNT, STEP_CREATE_ACCOUNT_REQUEST_VERIFICATION, STEP_PERSONAL_DETAILS, STEP_SERVICE_BREAKDOWN, STEP_SIGN_IN } from 'pages/CustomerBookingCreate/constants';
import { bookingState, stepState } from 'pages/CustomerBookingCreate/state';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { clientRegister } from 'services/authentication.service';
import locationsService from 'services/locations.service';
import { fingerprintState } from 'util/deviceUUID';
import { toasterror } from 'util/toasterror';
import { useTrackEvent } from 'util/trackEvent';
import * as Yup from 'yup';


const useStyles = makeStyles(theme => ({
  card: {
    padding: theme.spacing(5),
  },
  cardContent: {
    "&>*": {
      marginBottom: theme.spacing(5)
    }
  },
  cardAction: {
    justifyContent: 'flex-end'
  }
}));

const CreateAccountEmailScreen = ({ }) => {
  const classes = useStyles()
  const [step, setStep] = useRecoilState(stepState);
  const [error, setError] = useState(null);
  const [triggerSubmit, setTriggerSubmit] = useState(false);
  const fingerprint = useRecoilValue(fingerprintState)
  const [booking, setBooking] = useRecoilState(bookingState);
  const [loading, setLoading] = useState(false);
  const history = useHistory()
  const trackEvent = useTrackEvent()
  const setActiveUser = useSetRecoilState(activeUserState);

  const form = useMemo(
    () => {
      return {
        first_name: {
          type: 'text',
          label: 'First Name',
          fieldProps: {
            autoComplete: "off",
          },
          validator: () => Yup.string().required().nullable().label('First Name'),
        },
        last_name: {
          type: 'text',
          label: 'Last Name',
          fieldProps: {
            autoComplete: "off",
          },
          validator: () => Yup.string().required().nullable().label('Last Name'),
        },
        email: {
          type: 'email',
          label: 'Email',
          fieldProps: {
            autoComplete: "off",
          },
          validator: () => Yup.string().email().required().nullable().label('Email'),
        },
        password: {
          type: 'text',
          label: 'Password',
          fieldProps: {
            autoComplete: "off",
          },
          validator: () => Yup.string().min(8).required().nullable().label('Password'),
        },
      }
    }, []
  );

  const formLayout = useMemo(
    () => {
      return [['first_name', 'last_name'], ['email', 'password']]
    }, []
  );

  const onSubmit = useCallback(
    async (values) => {
      try {
        setLoading(true)
        const newClient = await clientRegister({ ...values, device_id: fingerprint })
        // const locationRes = await locationsService.addClientLocation(newClient?.client?.id, booking?.location)
        // setBooking({
        //   ...booking,
        //   location: locationRes
        // })
        if (process.env.REACT_APP_ENABLE_MOBILE_VERIFICATION === 'true') {
          history.replace(STEP_CREATE_ACCOUNT_REQUEST_VERIFICATION, { defer: true })
        } else {
          setStep(STEP_PERSONAL_DETAILS)
        }
        setLoading(false)
        setActiveUser(newClient)
      } catch (error) {
        trackEvent('Create Booking Sign Up - error', { error: error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details })
        setError(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details)
        toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details, {error})
        setLoading(false)
      }
    },
    [fingerprint],
  );
  return (
    <>
      <PageHeader
        title="Let’s create your account first"
        subheader={(
          <>
          An account is needed to continue booking. If you already have an account, great!
            {" "}<Link onClick={() => {
              setStep(STEP_SIGN_IN)
              history.replace(STEP_SIGN_IN, { defer: true })}
            }>Sign in instead.</Link>
          </>
        )}
        backStep={STEP_SERVICE_BREAKDOWN}
        currentStep={STEP_CREATE_ACCOUNT}
        showBreadcrumbs
        isCartEnabled={false}
        loading={loading}
      >
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            <FormBuilder
              variant="outlined"
              formFactor="default"
              hasReset={false}
              decouple
              triggerSubmit={triggerSubmit}
              onTriggerSubmit={v => {
                setTriggerSubmit(false)
              }}
              form={form}
              formLayout={formLayout}
              onSubmit={(v) => onSubmit(v)}
              fornm

            />
            <PrivPolLink/>
          </CardContent>
          <CardActions className={classes.cardAction}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                trackEvent('Create Booking Sign Up - continue')
                setTriggerSubmit(true)
              }}
            >
              Continue
            </Button>
          </CardActions>
        </Card>
      </PageHeader>
    </>
  )
}

export { CreateAccountEmailScreen }